// extracted by mini-css-extract-plugin
export default {"error":"px2kaAroQY2UGblWZiDM"};